module.exports = __webpack_public_path__ + "img/Monte_Kope_49.d581ae90.jpg";